import script from "./FirstSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FirstSection.vue?vue&type=script&setup=true&lang=ts"

import "./FirstSection.vue?vue&type=style&index=0&id=3ea0417a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ea0417a"]])

export default __exports__